import { createSlice } from '@reduxjs/toolkit';
import { logout } from './user';

const initialState = {
  hasWallet: false,
  walletId: null,
  name: null,
  balance: 0,
  creditLimit: 0,
  available: 0,
  currency: null,
  status: null,
  isFrozen: false,
  isLoading: false,
  hasLoaded: false,
  error: null,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    getWalletSummaryRequest: (state) => ({
      ...state,
      isLoading: true,
      error: null,
    }),
    getWalletSummarySuccess: (state, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
      hasLoaded: true,
      error: null,
    }),
    getWalletSummaryFailure: (state, { payload: { error } }) => ({
      ...initialState,
      hasWallet: state.hasWallet,
      hasLoaded: true,
      error,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { getWalletSummaryRequest, getWalletSummarySuccess, getWalletSummaryFailure } =
  walletSlice.actions;

export const getWallet = (store) => store.wallet;

export default walletSlice.reducer;
